@let page =
  pagesEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();

@if (page) {
  @let pageTitle = pageTitleSg();
  @let isCreating =
    pagesEc.plugins.currentEntityPlugin.feature.selectors
      .isCreating()
      .asSignal();

  <atn-ds-centered-overlay type="full-width">
    <div class="atn-mosaic-dev-page-dialog">
      <atn-ds-widget [title]="pageTitle">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>

        <div class="atn-mosaic-dev-page-dialog__body">
          <atn-ds-integrated-horizontal-tabs>
            <ng-template
              atnDsTab
              name="General"
            >
              <atn-mosaic-dev-page-general-tab />
            </ng-template>
            <ng-template
              atnDsTab
              name="Variables"
            >
              <atn-variables-builder />
            </ng-template>
          </atn-ds-integrated-horizontal-tabs>
        </div>

        <div
          footer
          class="atn-mosaic-dev-page-dialog__footer"
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button (click)="saveClickHandler()">{{
            isCreating ? 'Create' : 'Update'
          }}</atn-ds-button>
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
